__turbopack_context__.v({
  "chip": "size-module-scss-module__5B0opG__chip",
  "fill": "size-module-scss-module__5B0opG__fill",
  "info": "size-module-scss-module__5B0opG__info",
  "label": "size-module-scss-module__5B0opG__label",
  "limit": "size-module-scss-module__5B0opG__limit",
  "note": "size-module-scss-module__5B0opG__note",
  "progress": "size-module-scss-module__5B0opG__progress",
  "row": "size-module-scss-module__5B0opG__row",
  "slash": "size-module-scss-module__5B0opG__slash",
  "stat": "size-module-scss-module__5B0opG__stat",
  "value": "size-module-scss-module__5B0opG__value",
});
